import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import { injectIntl } from 'react-intl';
import getTranslatedText from '../../services/getTranslatedText';

const styles = {
  wrapper: {
    padding: 15
  },
};

class CsatByAnswerToOtherQuestionBarChart extends Component {
  render() {
    const intl = this.props.intl;
    const answersReport = this.props.answersReport;
    const csatByAnswerToOtherQuestion = answersReport ? answersReport.csatByAnswerToOtherQuestion : [];

    const categories = csatByAnswerToOtherQuestion.map(item => getTranslatedText(item.text, intl.locale));
    const data = csatByAnswerToOtherQuestion.map(item => item.csat * 100);

    const chartConfig = {
      chart: {
        type: 'bar',
        height: this.props.height - (styles.wrapper.padding * 2),
        width: this.props.width - (styles.wrapper.padding * 2),
      },
      title: {
        text: intl.formatMessage({ id: 'csatByAnswerToOtherQuestion' }),
        margin: 5,
        style: {
          fontSize: '14px',
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: function () {
          const index = categories.findIndex(x => x === this.x);
          return intl.formatMessage({
            id: 'numberOfAnswers',
          }, {
            count: csatByAnswerToOtherQuestion[index].count,
          });
        },
      },
      xAxis: {
        categories,
      },
      yAxis: {
        visible: false,
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: '{y:.0f}%',
          },
          pointPadding: 0,
          groupPadding: 0.1,
        },
      },
      series: [{
        data,
      }],
    };
    return (
      <div style={styles.wrapper}>
        <ReactHighcharts
          config={chartConfig}
          domProps={{ id: this.props.uniqueId }}
        />
      </div>
    );
  }
}

export default createFragmentContainer(
  injectIntl(CsatByAnswerToOtherQuestionBarChart),
  graphql`
    fragment CsatByAnswerToOtherQuestionBarChart_answersReport on AnswersReport {
      csatByAnswerToOtherQuestion(
        otherQuestionMongoId: $otherQuestionMongoId
      ) {
        text {
          language
          text
        }
        csat
        count
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/CsatByAnswerToOtherQuestionBarChart/CsatByAnswerToOtherQuestionBarChart.js